import styled from "@emotion/styled";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { TabUnderlineProps } from "./TabUnderline";
import { transitionDurationSeconds } from "./tabConstants";
import { tabsTheme } from "./tabsTheme";

interface TabUnderlineStyledProps extends TabUnderlineProps {
    themeMode: RequiredThemeKeys;
}

export const TabUnderlineStyled = styled("div")<TabUnderlineStyledProps>`
    position: absolute;
    bottom: 0;
    left: ${({ leftPx }) => leftPx}px;
    width: ${({ widthPlusUnit }) => widthPlusUnit};
    height: ${({ height = "2px" }) => height};
    background-color: ${({ backgroundColor }) => backgroundColor};

    ${({ underlineTransition, themeMode }) => {
        if (underlineTransition) {
            return `transition: width ${transitionDurationSeconds}s ${tabsTheme.underlineAnimation(
                themeMode
            )}, left ${transitionDurationSeconds}s ${tabsTheme.underlineAnimation(themeMode)};`;
        }
    }}
`;

TabUnderlineStyled.displayName = "TabUnderlineStyled";
